module.exports = __webpack_public_path__ + "static/media/banner2.2d6b1a8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/banner2.png
// module id = 41
// module chunks = 0